import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import * as depositWithdrawalService from '../services/depositWithdrawalService';
import {OPERATOR_ID} from '../configs/const';
class TransactionStatus extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            status: "",
            payment_status:"",
            responseCode: "",
            responseMsg: "",
            order_id: "",
            paymentType: "",
            amount: 0
        };
    }
    componentDidMount(){
        debugger
        this.setState({order_id: this.props.match.params.order_id},()=>{
            this.getOrderStatusDetails();
        })
    }
    
    getOrderStatusDetails(){
        const self = this
        depositWithdrawalService.getDepositOrderDetails(this.state.order_id).then((res) => {
            if (!!res){ // && res.isSuccess) {
                debugger
                self.setState({
                    status: res.orderStatus,
                    payment_status: res.paymentStatus,
                    responseMsg: res.message,
                    paymentType: "-",
                    amount: res.amount
                },()=>{
                    if(OPERATOR_ID === 'RDR' && window.location.origin === 'https://www.1xbook.com'){
                        self.postDepositSprtRdrCall(self.state.order_id, self.state.amount);
                    }
                })
            }
        })
    }
    postDepositSprtRdrCall(transactionId, amount){
        const prof_data = JSON.parse(localStorage.getItem('profData'));
        let payload = {action: "created", userId: prof_data.userId, transactionId: transactionId, amount: amount, currency: "INR" };
        // payload['label'] = "first_deposit"; only for first deposit
        window.sprtRdrCommonFunction("track.betting.deposit", payload);
        const randomNumber = Math.random() * 10000;
        const imgtag = document.createElement("img");
        imgtag.src = `https://ads.trafficjunky.net/tj_ads_pt?a=1000361991&member_id=1004644201&cb=${randomNumber}&cti=${this.state.order_id}&ctv=${this.state.amount}&ctd=${this.state.responseMsg}`
        imgtag.id = "1000361991_cpa_testing";
        imgtag.width = "1";
        imgtag.height = "1";
        imgtag.border = "0";
        document.getElementById('dvTransaction').appendChild(imgtag);
    }
    componentWillUnmount(){
        if(!!document.getElementById("1000361991_cpa_testing")){
            document.getElementById("1000361991_cpa_testing").remove();
        }
    }
    render() {
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id)=>{this.props.subscribe(type, id)}} subscriptions={this.props.subscriptions} history = {this.props.history} socket={this.props.socket}/>
                <div className="full-wrap">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className='mar-top100'>
                            <div className='allreport col3 min-height-800'>
                                <div className='d-flex justify-content-center'>
                                    <div id='dvTransaction' className='payment-methods__detail-form transaction-status__detail-form payment-box'>
                                        {this.state.status === "SUCCESS" ? 
                                            <>
                                                <p className='text-success text-16 line-height-07 text-center'><i className="fa fa-check-circle"></i></p>
                                                <h5 className='text-success text-8 text-center mb-30' id="myModalLabel">Payment Successful</h5>              
                                            </>
                                         : this.state.status === "CANCELLED" || this.state.status === "FAILED" ? 
                                            <>
                                                <p className='text-danger text-16 line-height-07 text-center'><i className="fa fa-close"></i></p>
                                                <h5 className='text-danger text-8 text-center mb-30' id="myModalLabel">Payment {this.state.status === "FAILED" ? "Failed" : "Cancelled"}</h5>              
                                            </>
                                         : this.state.status === "INITIATED" || this.state.status === "PROCESS" ? 
                                            <>
                                                <p className='text-warning text-16 line-height-07 text-center'><i className="fa fa-warning"></i></p>
                                                <h5 className='text-warning text-8 text-center mb-30' id="myModalLabel">Payment {this.state.status === "INITIATED" ? "Initiated" : "In Process"}</h5>              
                                            </> 
                                            :
                                            <></>
                                         }
                                        {/* <p className="lead text-center mb-4">We are processing the same and you will be notified via email.</p> */}
                                        {/* <h5 className="modal-title mt-0 text-black text-center" >Payment Successful</h5> */}
                                        <div className="row">
                                            <div className="col-sm text-muted-black font-16">Order Id</div>
                                            <div className={this.state.status === "SUCCESS" ? "col-sm text-sm-right font-weight-bold text-success font-16" : this.state.status === "CANCELLED" || this.state.status === "FAILED" ? "col-sm text-sm-right font-weight-bold text-danger font-16" : this.state.status === "INITIATED" || this.state.status === "PROCESS" ? "col-sm text-sm-right font-weight-bold text-warning font-16" : ""}>{this.state.order_id}</div>
                                        </div>
                                        <hr></hr>
                                        <div className="row">
                                            <div className="col-sm text-muted-black font-16">Order Status</div>
                                            <div className={this.state.status === "SUCCESS" ? "col-sm text-sm-right font-weight-bold text-success font-16" : this.state.status === "CANCELLED" || this.state.status === "FAILED" ? "col-sm text-sm-right font-weight-bold text-danger font-16" : this.state.status === "INITIATED" || this.state.status === "PROCESS" ? "col-sm text-sm-right font-weight-bold text-warning font-16" : ""}>{this.state.status}</div>
                                        </div>
                                        <hr></hr>
                                        {/* <div className="row">
                                            <div className="col-sm text-muted-black font-16">Payment Status</div>
                                            <div className={this.state.payment_status === "SUCCESS" ? "col-sm text-sm-right font-weight-bold text-success font-16" : this.state.payment_status === "FAILED" ? "col-sm text-sm-right font-weight-bold text-danger font-16" : "col-sm text-sm-right font-weight-bold text-warning font-16"}>{!!this.state.payment_status ? this.state.payment_status : ""}</div>
                                        </div>
                                        <hr></hr> */}
                                        <div className="row">
                                            <div className="col-sm text-muted-black font-16">Amount</div>
                                            <div className="col-sm text-sm-right text-black font-16">{this.state.amount}</div>
                                        </div>
                                        {/* <hr></hr>
                                        <div className="row">
                                            <div className="col-sm text-muted-black font-16">Response Message</div>
                                            <div className="col-sm text-sm-right text-black font-16">{this.state.responseMsg}</div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(TransactionStatus);